export interface SidebarFixatorConfig {
    sidebar: HTMLElement,
    footer: HTMLElement
}

export class SidebarFixator {
    protected sidebarTop: number;
    protected footerTop: number;
    protected sidebarHeight: number;
    private readonly elements: {
        sidebar: HTMLElement;
        footer: HTMLElement;
    };

    constructor({sidebar, footer}: SidebarFixatorConfig) {
        this.elements = {sidebar, footer};
        this.init();
    }

    protected updateSidebarTop(): void {
        this.sidebarTop = this.elements.sidebar.offsetTop;
    }

    protected onScroll(): void {
        const {sidebar} = this.elements;

        if (this.sidebarTop + this.sidebarHeight < this.footerTop) {
            let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
            let topPosition = Math.max(0, this.sidebarTop - scrollTop);

            if (topPosition === 0) {
                sidebar.classList.add(`is-fixed`);
            } else {
                sidebar.classList.remove(`is-fixed`);
                this.updateSidebarTop();
            }

            if (scrollTop + this.sidebarHeight > this.footerTop) {
                topPosition = Math.min(topPosition, this.footerTop - scrollTop - this.sidebarHeight);
            }

            sidebar.style.top = `${topPosition}px`;
        }
    }

    public init(): void {
        const {sidebar, footer} = this.elements;
        if (!sidebar || !footer) return;

        this.updateSidebarTop();
        this.sidebarHeight = sidebar.offsetHeight;
        this.footerTop = footer.offsetTop;

        window.addEventListener('scroll', () => this.onScroll());
    }
}